import React from 'react';
import { Layout, Menu } from 'antd';
import { 
  HomeOutlined, 
  AppstoreOutlined, 
  UserOutlined 
} from '@ant-design/icons';
import { Link, useLocation } from 'react-router-dom';

const { Footer } = Layout;

const FooterTabs = () => {
  const location = useLocation();

  // 移动端底部标签页菜单项
  const menuItems = [
    {
      key: '/home',
      label: <Link to="/home">首页</Link>,
      icon: <HomeOutlined />,
    },
    {
      key: '/web/tuku',
      label: <Link to="/web/tuku">图库</Link>,
      icon: <AppstoreOutlined />,
    },
    {
      key: '/web/tasks',
      label: <Link to="/web/tasks">工作台</Link>,
      icon: <AppstoreOutlined />,
    },
    {
      key: '/web/user',
      label: <Link to="/user">我的</Link>,
      icon: <UserOutlined />,
    },
  ];

  return (
    <Footer style={{ 
      background: '#0e1116',
      padding: 0,
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 1000,
      display: 'flex',
      justifyContent: 'center'
    }}>
      <Menu
        mode="horizontal"
        selectedKeys={[location.pathname]}
        style={{ 
          background: '#0e1116',
          border: 'none',
          width: '100%',
          display: 'flex',
          justifyContent: 'space-around',
          maxWidth: '500px' // 限制最大宽度以适应移动端
        }}
        items={menuItems}
      />
    </Footer>
  );
};

export default FooterTabs;